import { Box, Button, EditDate, Label, RadioButton } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { RadioGroup } from "Views/Mentors/Form/MentorDetail/StyleComponents";
import React from "react";
import { WeeklyRotaViewModel } from "../WeeklyRotaViewModel";
import { ClearButton } from "Components/General/ClearButton";
import { observer } from "mobx-react-lite";
import { Container, Footer, ButtonGroup, StyledDialog, Header } from "./AddWeeklyRotaModal.styles";

export interface IProps {
    viewModel: WeeklyRotaViewModel;
}

export const AddWeeklyRotaModal: React.FC<IProps> = observer((props: IProps) => {
    const { viewModel } = props;

    return (
        <>
            <StyledDialog open={true}>
                <Header>
                    Add weekly rota
                    <ClearButton command={viewModel.toggleWeeklyRotaModalOpenStateCommand} displayName={<CloseIcon />} />
                </Header>
                <Container>
                    <Box mb="10px">
                        <RadioButton
                            displayName="Do you want to copy a previous rota?"
                            command={viewModel.copyWeeklyDataCommand}
                            options={viewModel.copyWeeklyDataOptions}
                            value={() => viewModel.copyWeeklyData}
                        />
                    </Box>
                    {viewModel.copyWeeklyData && (
                        <EditDate
                            displayName="Date range of previous rota you want to copy"
                            value={() => viewModel.getValue("startDate")}
                            command={viewModel.updateRotaDateRangeCommand}
                            mode="date"
                            disableWeekends={true}
                        />
                    )}
                    <Footer>
                        <ButtonGroup>
                            <Button
                                command={viewModel.addWeeklyRotaCommandAsync}
                                paletteColor="primary"
                                animate={viewModel.isProcessing}
                                displayName={viewModel.addWeeklyRotaAddButtonDisplayName}
                            />
                            <Button command={viewModel.toggleWeeklyRotaModalOpenStateCommand} displayName={"CANCEL"} paletteColor="secondary" />
                        </ButtonGroup>
                    </Footer>
                </Container>
            </StyledDialog>
        </>
    );
});
